const itemAccomodation = {
  list_item: `
    <li class="col-lg-4 col-md-6 col-sm-12" data-id="{{id}}" data-top="{{top}}" data-price="{{price_raw}}" data-review="{{stars_raw}}">
      <a href="{{url}}" class="tile">
        <span class="tile__top">
          <span class="tile__tags">
            {{tag}}
            {{extra_tags}}
          </span>
          <span class="tile__gallery-controls js-accomodations-item-slider-controls"><span>{{icon_arrow}}</span><span>{{icon_arrow}}</span></span>
          <span class="tile__gallery-nav js-accomodations-item-slider-nav">{{nav_buttons}}</span>
          <span class="tile__gallery js-accomodations-item-slider">{{gallery_items}}</span>
        </span>
        <span class="tile__main">
          <span class="tile__info">
            {{stars}}
            <span>{{country_name}}</span>
            <span>|</span>
            <span>{{region}}</span>
            <span>|</span>
            <span class="tile__persons"><span>{{icon_bed}}</span><span>{{persons}}</span></span>
          </span>
          <span class="tile__headline">{{name}}</span>
          <span class="tile__price">{{price}}</span>
          <span class="tile__author">{{author}}</span>
        </span>
      </a>
    </li>
  `,
  list_item_service: `
    <li class="col-lg-4 col-md-6 col-sm-12" data-id="{{id}}" data-top="{{top}}" data-price="{{price_raw}}" data-review="{{stars_raw}}">
      <a href="{{url}}" class="tile">
        <span class="tile__top">
          <span class="tile__tags">
            {{tag}}
            {{extra_tags}}
          </span>
          <span class="tile__gallery-controls js-accomodations-item-slider-controls"><span>{{icon_arrow}}</span><span>{{icon_arrow}}</span></span>
          <span class="tile__gallery-nav js-accomodations-item-slider-nav">{{nav_buttons}}</span>
          <span class="tile__gallery js-accomodations-item-slider">{{gallery_items}}</span>
        </span>
        <span class="tile__main">
          <span class="tile__info">
            {{stars}}
            <span>{{country_name}}</span>
            <span>|</span>
            <span>{{region}}</span>
          </span>
          <span class="tile__headline">{{name}}</span>
          <span class="tile__price">{{price}}</span>
          <span class="tile__author">{{author}}</span>
        </span>
      </a>
    </li>
  `,
  gallery_item: `<span><img src="{{img}}" alt=""></span>`,
  tag: `<span class="tile__tag">{{tag_img}}<span>{{tag}}</span></span>`,
  extra_tag: `<span class="tile__tag {{frontend_color_class}}">{{frontend_icon}}<span>{{name_for_users}}</span></span>`,
  extra_tag_showing_on: `<span class="tile__tag success">` + sikmoVars.icons.eye_green + `<span>` + sikmoVars.translation.showing + `</span></span>`,
  extra_tag_showing_off: `<span class="tile__tag danger">` + sikmoVars.icons.eye_red + `<span>` + sikmoVars.translation.not_showing + `</span></span>`,
  extra_tag_paid_on: `<span class="tile__tag success"><span>` + sikmoVars.translation.paid + `</span></span>`,
  extra_tag_paid_off: `<span class="tile__tag danger"><span>` + sikmoVars.translation.not_paid + `</span></span>`,
  stars: `<span class="tile__star">{{stars}}</span><span>|</span>`,
};

export default itemAccomodation;